import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/cal-ay/apps/web/modules/apps/apps-view.tsx");
